<template>
    <b-button
        variant="danger"
        @click.stop="confirmarExcluirSelecionados()"
        :disabled="comprometimentosSelecionados.length == 0"
        v-if="$temAcessoView('CONT-REQ-05')"
    >
        <span><i class="fa fa-trash mr-2"></i> Excluir rateios selecionados</span>
    </b-button>
</template>

<script>
export default {
    components: {},

    props: {
        requisicao: {
            type: Object,
            default: () => ({})
        },

        comprometimentosSelecionados: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarExcluirSelecionados() {
            const quantidade = this.comprometimentosSelecionados.length
            const mensagem = `Confirma a exclusão de ${quantidade}
                              rateio(s) selecionado(s) da requisição?`
            this.$swal({
                title: 'Exclusão de rateios',
                html: mensagem,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.excluirSelecionados()
                }
            })
        },

        excluirSelecionados() {
            this.$emit('excluirRateiosSelecionados')
        }
    },

    created() {},

    computed: {},

    watch: {},

    validations: {}
}
</script>
